/** 1234567 → "1 234 567" с неразрывными пробелами. */
export function formatNumber(n: number | string | null | undefined): string {
  if (n === null || n === undefined || n === "") return "";
  const value = typeof n === "string" ? Number(n) : n;
  if (!Number.isFinite(value)) return String(n);
  return Math.round(value).toLocaleString("ru-RU").replace(/ |\s/g, " ");
}

const _MONTHS = [
  "января", "февраля", "марта", "апреля", "мая", "июня",
  "июля", "августа", "сентября", "октября", "ноября", "декабря",
];

/**
 * Бэкенд пишет datetime как **naive UTC** (без `Z` / `+00:00`).
 * `new Date(...)` без TZ-суффикса интерпретирует строку как **локальное**
 * время браузера → юзер на МСК видит «3 часа назад» сразу после старта.
 *
 * Эта функция дописывает `Z`, если суффикс отсутствует, и парсит как UTC.
 */
export function parseUtc(iso: string | Date): Date {
  if (iso instanceof Date) return iso;
  const looksTimezoned = /Z$|[+-]\d{2}:?\d{2}$/.test(iso);
  return new Date(looksTimezoned ? iso : iso + "Z");
}

/** ISO → "14 мая 2026, 19:32". */
export function formatDate(iso: string | Date | null | undefined): string {
  if (!iso) return "";
  const d = parseUtc(iso);
  if (Number.isNaN(d.getTime())) return "";
  const day = d.getDate();
  const month = _MONTHS[d.getMonth()];
  const year = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${day} ${month} ${year}, ${hh}:${mm}`;
}

/** ISO → "14 мая, 19:32" (без года, для коротких карточек). */
export function formatDateShort(iso: string | Date | null | undefined): string {
  if (!iso) return "";
  const d = parseUtc(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getDate()} ${_MONTHS[d.getMonth()]}, ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

/** «3 ч назад» / «5 мин назад». UTC-aware. */
export function formatTimeAgo(iso: string | Date | null | undefined): string {
  if (!iso) return "";
  const d = parseUtc(iso);
  if (Number.isNaN(d.getTime())) return "";
  const ms = Date.now() - d.getTime();
  if (ms < 0) return "только что";
  const sec = Math.floor(ms / 1000);
  if (sec < 5) return "только что";
  if (sec < 60) return `${sec} сек назад`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} мин назад`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} ч назад`;
  const days = Math.floor(hr / 24);
  return `${days} дн назад`;
}

/** Сокращение длинной строки в одной строке: 80 → "..." */
export function truncate(s: string, max = 80): string {
  if (s.length <= max) return s;
  return s.slice(0, max - 1).trimEnd() + "…";
}
